<template>
  <div>
    <Icon
      v-if="isIcon"
      :class="[iconClass, $style.reduceLine]"
      :icon="iconType"
      :scale="2.5"
    />
    <ParagraphBody
      v-else
      :class="[singleValueClass, $style.reduceLine]"
      weight="bold"
    >
      <span
        v-if="isRatio"
        :class="$style.value"
      >
        {{ metric.count }}
      </span>
      {{ metricValue }}{{ percentSymbol }}
    </ParagraphBody>

    <Tooltip
      v-if="metric.definition"
      :hasIndicator="false"
      icon="info"
      :isMarkdown="false"
      orientation="bottom"
      :text="metric.definition"
    >
      <ParagraphBody
        :class="$style.underline"
      >
        {{ metric.label }}
      </ParagraphBody>
    </Tooltip>
    <ParagraphBody v-else>
      {{ metric.label }}
    </ParagraphBody>
  </div>
</template>

<script>
import { Icon, ParagraphBody, Tooltip } from '@jumpcloud/ui-components';
import { valueReportStatTypes } from 'client/GrowthEngineering/utilities/GrowthConstants';

export default {
  name: 'Stat',

  components: {
    Icon,
    ParagraphBody,
    Tooltip,
  },

  props: {
    metric: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      type: {
        boolean: {
          true: false,
          false: false,
        },
        ratio: false,
        stat: false,
        percent: false,
        total: false,
        definition: {
          tyep: String,
          default: '',
        },
      },
    };
  },

  computed: {
    iconClass() {
      return this.metric.value ? this.$style.trueIcon : this.$style.singleValueClass;
    },

    iconType() {
      return 'checkmarkCircle';
    },

    isIcon() {
      return this.metric.type === valueReportStatTypes.boolean && this.metric.value === true;
    },

    isRatio() {
      return this.metric.type === valueReportStatTypes.ratio;
    },

    metricValue() {
      if (this.metric.type === valueReportStatTypes.boolean && this.metric.value === false) {
        return 'No';
      }
      if (this.isRatio) {
        return `/${this.metric.total}`;
      }
      return this.metric.value;
    },

    percentSymbol() {
      return this.metric.type === valueReportStatTypes.percent ? '%' : '';
    },

    singleValueClass() {
      return this.metric.type !== valueReportStatTypes.ratio ? this.$style.value : '';
    },
  },
};
</script>

<style module scoped>
.value.value {
  font-size: var(--jcHeadingHuge);
}

.reduceLine.reduceLine {
  line-height: 1;
}

.trueIcon {
  color: var(--jc-color-success-base);
}

.falseIcon {
  color: var(--jc-color-warning-base);
}

.underline {
  text-decoration: underline;
}
</style>
